import { __rest } from "tslib";
import { forwardRef, useRef, useEffect } from 'react';
import { createReactWrapper } from '../../common/PrefixUtils';
import { handleForwardRef } from '../../common/RefUtils';
export const DataTableHeaderCellV2 = forwardRef((_a, ref) => {
    var { onSort } = _a, props = __rest(_a, ["onSort"]);
    const cellRef = useRef();
    const handledRef = handleForwardRef(cellRef, ref);
    const handleSort = (event) => {
        onSort === null || onSort === void 0 ? void 0 : onSort(event);
    };
    useEffect(() => {
        if (cellRef.current) {
            // @ts-expect-error ts throws an error here because it does not recognize a custom sort event exits
            cellRef.current.addEventListener('sort', handleSort);
        }
        return () => {
            var _a;
            // @ts-expect-error ts throws an error here because it does not recognize a custom sort event exits
            (_a = cellRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('sort', handleSort);
        };
    }, [cellRef, onSort]);
    return createReactWrapper({
        tagName: 'chameleon-data-table-header-cell-v2',
        props: Object.assign(Object.assign({}, props), { ref: handledRef }),
        children: props.children,
    });
});
